import Ticker from "../components/Ticker";

const TopLeft = ({ gameData }) => {
  if (!gameData) return null;

  const labelMap = {
    SOG: "Shots on goal",
    FOW: "Faceoffs",
    PIM: "Penalties (min)",
  };

  const renderPass = () =>
    gameData.Statistics.map((s, i) => (
      <div
        key={`s-${i}`}
        className="mx-4 flex items-center gap-1 whitespace-nowrap py-0.5 text-3xl text-white"
      >
        <span className="mr-1 text-3xl font-normal text-gray-400">
          {labelMap[s.type] || s.type}:
        </span>
        <img
          src={gameData.HomeTeam.logo}
          alt={gameData.HomeTeam.short}
          className="h-8 w-8 object-contain"
        />
        <p className="min-w-[90px] justify-center font-number flex items-center gap-1">
          <span>{s.homeTeamValue}</span>
          <span>/</span>
          <span>{s.awayTeamValue}</span>
        </p>
        <img
          src={gameData.AwayTeam.logo}
          alt={gameData.AwayTeam.short}
          className="h-8 w-8 object-contain"
        />
      </div>
    ));

  return (
    <div className="flex min-h-[56px] w-full items-center overflow-hidden rounded-br-lg bg-gray-700 px-3 font-exo-two">
      <Ticker>{renderPass()}</Ticker>
    </div>
  );
};

export default TopLeft;
